import { useState } from 'react';
import { impersonationService } from '@/services/supabase/impersonationService';
import { getRoleLabel } from '@/features/auth/utils/roleLabels';

/**
 * Barra fixa exibida enquanto um SUPER_ADMIN está personificando outro usuário.
 * Fica montada em AppProviders, portanto aparece em todas as telas.
 */
export function ImpersonationBanner() {
  const [encerrando, setEncerrando] = useState(false);
  const target = impersonationService.getTarget();

  if (!target) return null;

  const nome = [target.first_name, target.last_name].filter(Boolean).join(' ').trim()
    || target.username
    || target.email;

  const handleEncerrar = async () => {
    setEncerrando(true);
    try {
      await impersonationService.encerrar();
    } catch (error) {
      console.error('Erro ao encerrar personificação:', error);
      setEncerrando(false);
    }
  };

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: '8px 16px',
        backgroundColor: '#b45309',
        color: '#fff',
        fontSize: 14,
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
      }}
    >
      <span>
        Você está personificando <strong>{nome}</strong>
        {target.role ? ` (${getRoleLabel(target.role)})` : ''}
      </span>
      <button
        type="button"
        onClick={handleEncerrar}
        disabled={encerrando}
        style={{
          border: '1px solid #fff',
          background: 'transparent',
          color: '#fff',
          padding: '2px 12px',
          borderRadius: 6,
          cursor: encerrando ? 'default' : 'pointer',
          fontSize: 13,
          opacity: encerrando ? 0.7 : 1,
        }}
      >
        {encerrando ? 'Saindo…' : 'Sair da personificação'}
      </button>
    </div>
  );
}
